// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import { getNotifications } from 'api/notifications';
import moment from 'moment';

// ----------------------------------------------------------------------

const defaultParams = {
    pageNo: 1,
    perPage: 5,
    dateFrom: moment(new Date()).startOf('day'),
    currentDateTime: new Date(),
    showType: 'all'
};

const initialState = {
    notifications: [],
    params: defaultParams,
    notificationsCount: 0,
    unreadCount: 0,
    isFetchingNotifications: true
};

const slice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        // SET Notifications
        setNotifications(state, action) {
            const { data, isUpdateTotalCount } = action.payload;
            const { list = [], summary = {} } = data;
            const { total = 0, unreadCount = 0 } = summary;
            state.notifications = list;
            state.unreadCount = unreadCount;

            // we will update the count
            if (state.notificationsCount === 0 || isUpdateTotalCount) {
                state.notificationsCount = total;
            }
        },
        // SET Params
        setParams(state, action) {
            state.params = action.payload;
        },
        // SET Is Fetcing Notifications
        setIsFetchingNotifications(state, action) {
            state.isFetchingNotifications = action.payload;
        },
        // SET Unread Count
        setUnreadCount(state, action) {
            state.unreadCount = action.payload;
        }
    }
});

// eslint-disable-next-line prettier/prettier
export const {
    setNotifications,
    setParams,
    setIsFetchingNotifications,
    setUnreadCount
} = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchNotifications(params, isUpdateTotalCount = false) {
    return async () => {
        try {
            const result = await getNotifications(params);
            dispatch(
                slice.actions.setNotifications({
                    data: result?.data || {},
                    isUpdateTotalCount
                })
            );
            return result?.data?.list || [];
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setNotifications({
                    data: {}
                })
            );
            return [];
        }
    };
}
